import axios from './axiosConfig'
import { getEnv } from '@utils/env'
import {
  IClinicHolidays,
  ISaveClinicHolidaysPayload,
} from '@dataTypes/clinic-holidays.type'

const CLINIC_BUSINESS_API = getEnv('REACT_APP_BUSINESS_LAYER_CLINIC')

interface ApiEnvelope<T> {
  statusCode: number
  message: string
  data: T
}

export const fetchClinicHolidaysApi = async (
  clinicId: string,
): Promise<ApiEnvelope<{ clinic_holidays: IClinicHolidays }>> => {
  const response = await axios.get<
    ApiEnvelope<{ clinic_holidays: IClinicHolidays }>
  >(`${CLINIC_BUSINESS_API}/api/v1/clinic/holidays`, {
    params: { clinic_id: clinicId },
  })
  return response.data
}

export const saveClinicHolidaysApi = async (
  clinicId: string,
  payload: ISaveClinicHolidaysPayload,
): Promise<ApiEnvelope<{ clinic_holidays: IClinicHolidays }>> => {
  const response = await axios.put<
    ApiEnvelope<{ clinic_holidays: IClinicHolidays }>
  >(`${CLINIC_BUSINESS_API}/api/v1/clinic/holidays/${clinicId}`, payload)
  return response.data
}
